import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { RetornoSelecao } from '../../../shared/gridview/RetornoSelecao';
import { Estado } from '../../../shared/shared/estado.enum';

// oculta o botão de novo cadastro do componente.
export let ocultaBotao = true;

declare var $: any;

@Component({
  selector: 'app-produtividade',
  templateUrl: './produtividade.component.html',
  styleUrls: ['./produtividade.component.css']
})
export class ProdutividadeComponent implements OnInit {
  carregando: any;
  router: Router;
  selecionado: object;
  state: Estado = Estado.view;

  filtros = {};
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query

  constructor() {
  }

  ngOnInit() {
    this.InicialData = moment(this.InicialData).startOf('month').format('YYYY-MM-DD');
        
    this.FinalData = moment(this.FinalData).format('YYYY-MM-DD');

    this.filtros = { data_inicial: this.InicialData, data_final:  this.FinalData, };
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
      if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $('#produtividade-filtro').modal();
  }

}
